import initialState from './initialState'

const SET_TYPE_MOVEMENT = function(state, payload) {
    state.typeMovement = payload
}

const SET_MOVEMENT = function(state, payload) {
    state.movement = payload
}

const SET_DATE = function(state, payload) {
    state.date = payload
}

const SET_CASH_AMOUNT = function(state, payload) {
    state.cashAmount = payload
}

const SET_COMMENT = function(state, payload) {
    state.comment = payload
}

const SET_MOVEMENT_TYPE = function(state, payload) {
    state.movementType = payload
}

const SET_INGRESS_TYPES = function(state, payload) {
    state.arrayIngressType = payload
}

const SET_EGRESS_TYPES = function(state, payload) {
    state.arrayEgressType = payload
}


const SET_UNIQUE_KEY = function(state, payload) {
    state.uniqueKey = payload
}

const RESET_STATE = function(state) {
    state.typeMovement= null //more explicative than "movement"
    state.movement= null
    state.date= null
    state.cashAmount= null
    state.comment= null
    //state.reason= null
    state.showModal= false
}

// const SHOW_MODAL = function(state) {
//     state.showModal = true
// }

// const HIDE_MODAL = function(state) {
//     state.showModal = false
// }

export default {
    SET_TYPE_MOVEMENT,
    SET_MOVEMENT,
    SET_DATE,
    SET_CASH_AMOUNT,
    SET_MOVEMENT_TYPE,
    SET_COMMENT,
    SET_INGRESS_TYPES,
    SET_EGRESS_TYPES,
    SET_UNIQUE_KEY,
    RESET_STATE,
    // SHOW_MODAL,
    // HIDE_MODAL
}
